// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + "f7a8eea17e6e1988a616" + ".chunk.js";
};